var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStoresOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stores-Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821",
    transform: "translate(-4811.367 -2594.475)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(4752.207 2597.385)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_74",
    "data-name": "Subtraction 74",
    d: "M7.159,19.091a.6.6,0,0,1-.423-.173C6.461,18.643,0,12.112,0,7.16a7.159,7.159,0,1,1,14.318,0c0,4.792-6.042,11.055-6.731,11.753l-.005,0A.608.608,0,0,1,7.159,19.091Zm0-15.509A3.58,3.58,0,1,0,10.737,7.16,3.582,3.582,0,0,0,7.156,3.582Zm0,5.966A2.386,2.386,0,1,1,9.543,7.16,2.389,2.389,0,0,1,7.156,9.548Z",
    transform: "translate(64.001 -0.002)",
    fill: "#da291c"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4499",
    "data-name": "Rectangle 4499",
    width: 24,
    height: 24,
    transform: "translate(4811.367 2594.475)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStoresOn);
export default __webpack_public_path__ + "static/media/icon_stores_on.de8e4eaa956b88e2b1e6fe734c961b73.svg";
export { ForwardRef as ReactComponent };